module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/core-js@2.6.12/~/core-js/modules/_library.js
// module id = 51
// module chunks = 0